import { useState } from 'react';
import { getLastAvailablePaymentMethods } from '@shared/core/stripe/LoadingExpressCheckoutElement';
import type { ItemWithPrice } from '@apps/registry/common/selectors/ProductListSelector';
import { isCustomDonationFundItem } from '@apps/registry/common/selectors/ProductListSelector';
import { useGetCatalogItemId } from '@apps/registry/common/components/Catalog/hooks/productPdp';

export type ToastVariableProps = {
  notificationText: string;
  isPositionTop?: boolean;
  noAnimation?: boolean;
};

const initValueToastVariable = {
  notificationText: '',
};

export const useGuestRegistryController = () => {
  const [notificationVisible, setNotificationVisible] = useState(false);
  const [toast, setToast] = useState<ToastVariableProps>(initValueToastVariable);

  const openToast = (toast: ToastVariableProps) => {
    setToast(toast);
    setNotificationVisible(true);
  };

  return {
    toast: { ...toast, notificationVisible, setNotificationVisible },
    openToast,
  };
};

export const useGetPaymentPlatform = (product: ItemWithPrice): 'apple' | 'google' | null => {
  const availablePaymentMethods = getLastAvailablePaymentMethods();

  const catalogItemId = useGetCatalogItemId(product);
  const isDropshipable = !!catalogItemId;

  const isCashFund = isCustomDonationFundItem(product);
  const enableJoyCredit = product?.donationFund?.fund?.enableJoyCredit;

  // Only show payment icons for dropships and cash funds

  if (!isDropshipable && !(isCashFund && enableJoyCredit)) {
    return null;
  }

  if (availablePaymentMethods?.applePay) {
    return 'apple';
  }

  if (availablePaymentMethods?.googlePay) {
    return 'google';
  }

  return null;
};
